import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import axios from 'axios'
axios.defaults.withCredentials=false

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  console.log('Axios Request:', config.url, config)
  return config
}, function (error) {
  console.error('Axios Request Error:', error)
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  console.log('Axios Response:', response.config.url, response)
  return response
}, function (error) {
  console.error('Axios Response Error:', error)
  if (error.response) {
    console.error('Error Response Data:', error.response.data)
    console.error('Error Response Status:', error.response.status)
  }
  return Promise.reject(error)
})

Vue.prototype.axios = axios

import qs from 'qs';
Vue.prototype.qs = qs

import VueWechatTitle from 'vue-wechat-title'

import vant from 'vant'
import 'vant/lib/index.css'
Vue.use(vant)

import Router from 'vue-router'
Vue.use(Router)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.use(VueWechatTitle)

import { router } from './router/index'

// 引入 vConsole
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// console.log('vConsole initialized')

// 全局错误捕获
Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error Handler:', err)
  console.error('Error Info:', info)
  console.error('Component:', vm)
}

window.onerror = function (message, source, lineno, colno, error) {
  console.error('Global Error:', message)
  console.error('Source:', source)
  console.error('Line:', lineno, 'Col:', colno)
  console.error('Error Object:', error)
}

// 拦截未处理的 Promise 拒绝
window.addEventListener('unhandledrejection', function (event) {
  console.error('Unhandled Promise Rejection:', event.reason)
})

new Vue({
  router,
  render: create => create(App)
}).$mount('#app');
